import { render } from "./ConsentVersionsList.vue?vue&type=template&id=71351347&ts=true"
import script from "./ConsentVersionsList.vue?vue&type=script&lang=ts"
export * from "./ConsentVersionsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Consents/ConsentVersionsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71351347"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71351347', __exports__)) {
    api.reload('71351347', __exports__)
  }
  
  module.hot.accept("./ConsentVersionsList.vue?vue&type=template&id=71351347&ts=true", () => {
    api.rerender('71351347', render)
  })

}


export default __exports__